module.exports = __webpack_public_path__ + "img/reference30.8ac31066.jpg";